import { apiUrls } from '../modules/services/apiConfig';
import { HttpService, getChannelId } from '../../../../services/HttpService';
import { getAEMBaseUrl, getDigitalURL } from '../../../../services/UrlMapperService';
import { isWHW, isWHWP2, getFlowTypeWithIntend } from '../../../common/Helpers/index';
import { getApiUrls } from '../../../../constants/apiUrl';
import { removeCartItemPayload, addRemoveAccessoriesPayload, promoCodePayload } from '../Helper/payloadHelper';

const commonHeader = { flowName: `${getFlowTypeWithIntend()}` };

export const getCheckoutCQ = () => {
  const apiURL = `${getAEMBaseUrl('content/vcg')}${apiUrls.checkoutCaas}`;
  return HttpService.post(apiURL);
};

export const getCheckoutDetailsApi = (data = {}) => {
  const { cart = false, customerAgreements = false, paymentOptions = false, shippingOptions = false } = data?.data;
  const postData = {
    clientCorrelationId: '',
    customerTypeParam: null,
    optimizeSDD: 'N',
    cart,
    customerAgreements,
    installmentContracts: false,
    paymentOptions,
    shippingOptions,
    smsEnabledOptions: false,
    iconicFlags: {
      disableISPU: false,
      disableSDD: false,
      disableISAAC: false,
      disableEdgeUpISPUSDD: false,
    },
  };
  const apiUrl = getDigitalURL(apiUrls.getCheckoutDetails);

  return HttpService.post(apiUrl, postData);
};

export const validEmailIdAPI = (data) => {
  const postData = {
    meta: {
      client: getChannelId(), // getChannelId(),
      user: '',
      clientCorrrelationId: '',
      timestamp: '',
    },
    data: {
      emailId: data.email || data.email_shell,
      userAction: data.userAction || 'updateContactInfo',
      customerType: 'Wireless',
      version: 'v2',
    },
  };

  postData.data.amRegistrationRequired = true;
  const apiUrl = getDigitalURL(apiUrls.validEmailApi, true);
  return HttpService.post(apiUrl, postData);
};

export const verifyEmailIdAPI = (data) => {
  const postData = {
    data: {
      action: 'manual',
      email: data,
      prospectCustomer: true,
    },
  };

  const apiUrl = getDigitalURL(apiUrls.verifyEmailApi);

  return HttpService.post(apiUrl, postData);
};

export const verifyMobileNoApi = (data) => {
  const postData = { data: { mtn: data, purposeName: 'Transactional', lineOfBusiness: 'Wireless', flowName: 'FWA Contact Info Order' } };
  const apiUrl = getDigitalURL(apiUrls.verifyMobileApi);
  return HttpService.post(apiUrl, postData);
};

export const addRemoveAccessories = (value = {}) => {
  const postData = addRemoveAccessoriesPayload(value);
  const apiURL = getDigitalURL(getApiUrls.addAccessories);
  const Data = isWHW() || isWHWP2() ? HttpService.post(apiURL, postData, { headers: commonHeader }) : HttpService.post(apiURL, postData);
  return Data;
};

export const addRemoveYtTv = (value = {}) => {
  if (value.description === 'VIDEO') {
    const postData = removeCartItemPayload(value);
    const apiURL = getDigitalURL(getApiUrls?.addFeatures);
    return HttpService.post(apiURL, postData);
  }
  if (value?.itemType === 'DEVICE') {
    const postData = removeCartItemPayload(value);
    const apiURL = getDigitalURL(getApiUrls.removeHomePhone);
    return HttpService.post(apiURL, postData);
  }
};

export const isExpresscheckoutPromoValid = (data) => {
  const postData = promoCodePayload(data);
  const apiURL = getDigitalURL(getApiUrls.isCouponValid);
  return HttpService.post(apiURL, postData);
};
